import Chaplin from 'chaplin';

const Portfolio = Chaplin.Model.extend({});

export default Portfolio;
